
















import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component
export default class CSimpleTable extends Vue {
    @Prop({default: false, type: Boolean}) dense!: boolean;
    @Prop({default: false, type: Boolean}) light!: boolean;
    @Prop({default: false, type: Boolean}) dark!: boolean;
    @Prop({default: false, type: Boolean}) fixedHeader!: boolean;
    @Prop({default: false, type: Boolean}) bordered!: boolean;
    @Prop({default: false, type: Boolean}) loading!: boolean;
    @Prop() height!: string | number | undefined;

    get tableClass() {
        const result = [];
        if (this.light) {
            result.push('theme--light');
        } else if (this.dark) {
            result.push('theme--dark');
        } else {
            result.push('theme--light');
        }
        if (this.dense) {
            result.push('v-data-table--dense');
        }
        if (this.bordered) {
            result.push('v-data-table--bordered');
        }
        return result;
    }

    get tableStyle() {
        return {
            height: this.tableHeight,
            overflowY: this.tableHeight ? 'auto' : '',
        };
    }

    get tableHeight() {
        if (this.height) {
            if (typeof this.height === 'number') return `${this.height}px`;
            else return this.height;
        }
        return null;
    }

    @Watch('fixedHeader', {immediate: true})
    onFixedHeaderChange(value: boolean) {
        if (!this.$el) {
            this.$nextTick().then(() => {
                this.onFixedHeaderChange(value);
            });
            return;
        }
        const thCollection = this.$el.querySelectorAll('thead th');
        if (value) {
            thCollection.forEach((th: any) => {
                th.classList.add('sticky');
                th.style.top = th.offsetTop + 'px';
                th.style.background = '#fff';
            });
        } else {
            thCollection.forEach((th: any) => {
                th.classList.remove('sticky');
                th.style.top = '';
                th.style.background = '';
            });
        }
    }
}
